'use-strict'
import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { axiosInstanceQMS } from "../../utils/axiosConfig";
import moment from "moment";
import QMSErrorHandle from '../auxil/QMSErrorHandle';
import CommonConfig from '../commonConfig.json';

import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import setFiletraceContentLoading from '../../store/actions/filetraceActions'
import {setToggleSidebar, setSidebarSelected} from '../../store/actions/navbarActions'

import { Menu, Layout } from 'antd';
import "./SideBar.css";
import 'antd/dist/antd.css';
import { FileSearchOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const { SubMenu } = Menu;
const { Sider } = Layout;

let accessType = CommonConfig.accessTypes;
let apps = CommonConfig.apps;

// const REACT_APP_SSO_URL = process.env["REACT_APP_SSO_URL"];

class SideBar extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            selectedMenu: ["filetrace"],
            selectedItems: [],
            afterKey : 0,
            archiveKey : 0,
            pageSize : 15,
            sessions : {},
            solution : {
                solutionName : "",
                projectDetails : []
            },
            allowedConnectors : [],
            uniqueIndexes : [],
            emptyFileTrace : false,
            winWidth:window.innerWidth,
            winHeight:window.innerHeight,
            // isOpen : (this.props.appToLoad === apps.QMS ? true : false)
        }

        this.scrollMenu = this.scrollMenu.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    //sessions = [];
    firstDate = null;
    firstTime = null;
    firstExe = true;
    endOfData = false;
    apiCalled = false;
    errorObject = {
        err: false, 
        errCode: null, 
        errType: null, 
        errMsg: null, 
        display : false
    };
    absoluteInit = true;

    updateDimensions = () => {
        this.setState({
            winWidth: window.innerWidth, 
            // winHeight: window.innerHeight 
        });
    }

    printError(newError){
        this.errorObject = newError;
        this.forceUpdate();
        //this.setState({ alertObj : ""});
        setTimeout(() => { 
            this.errorObject = {
                err: false, 
                errCode: null, 
                errType: null, 
                errMsg: null, 
                display : false
            }
        },
        1000);
    }

    handleMe(key, level, setSession) {
        this.props.setSidebarSelected(true);
        //alert(key+" : "+JSON.stringify(this.state.selectedItems));
        let date = null;
        let time = null;
        if (level === "d") {
            if(this.props.accessType === accessType.END_USER){
                let stateMenu = [...this.state.selectedMenu];
                if (stateMenu.includes(key)) {
                        stateMenu.splice(stateMenu.indexOf(key), 1);
                } else {
                    stateMenu.push(key);
                    date = key;
                }
                this.setState({ selectedMenu: stateMenu }, () => {
                    // alert(JSON.stringify(this.state.selectedMenu));
                    // alert(JSON.stringify(this.state.selectedItems));
                });

            }else{

                if(setSession){
                    date = key;
                }

                let stateItem = [...this.state.selectedItems];
                stateItem = [key];
            
                this.setState({ selectedItems: stateItem }, () => {
                    // alert(JSON.stringify(this.state.selectedMenu));
                    // alert(JSON.stringify(this.state.selectedItems));
                });
            }
        }else if (level === "t") {
            if(setSession){
                date = key.split("_")[0];
                time = key.split("_")[1];
            }

            let stateItem = [...this.state.selectedItems];
            stateItem = [key];
        
            this.setState({ selectedItems: stateItem }, () => {
                // alert(JSON.stringify(this.state.selectedMenu));
                // alert(JSON.stringify(this.state.selectedItems));
            });
        }else if (level === "o"){
            let stateMenu = [...this.state.selectedMenu];
            stateMenu = []
            let stateItem = [...this.state.selectedItems];
            stateItem = [key];

            this.setState({
                selectedItems: stateItem,
                selectedMenu: stateMenu
            });
        }

        if(setSession) {
            //set session data to pass sibling <Content>
            let sessionData = {
                date: date,
                time: time,
                sidebarClick: true
            };

            // pass data through session storage
            sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
        }
    }

    scrollMenu() {
        if(!this.endOfData){
            let container = document.getElementById("filetrace$Menu");
        
            if(container != null){
                let shei = container.scrollHeight;
                let scY = container.scrollTop;
                let clHei = container.clientHeight;
            
                if (shei === scY + clHei) {
                  console.log("SCROLL BOTTOM");
                  this.createContent(false, true)
                } else if (scY === 0) {
                  //console.log("SCROLL TOP");
                }
            }
        }
    }

    componentWillReceiveProps(newprops){
        console.log("Comparison", newprops.sideBarSelected, this.props.sideBarSelected)
        if(newprops.solution !== undefined && (newprops.sideBarSelected === this.props.sideBarSelected)){
          
            this.apiCalled = false;
            this.firstExe = true;
            this.firstTime = null;
            this.firstDate = null;
            this.setState({
                solution : newprops.solution,
                allowedConnectors : newprops.allowedConnectors,
                uniqueIndexes : newprops.uniqueIndexes,
                sessions : {},
                afterKey : 0,
                archiveKey : 0,
                selectedMenu: ["filetrace"],
                selectedItems: [],
            }, () => {
                this.createContent(true, true);
            });

        }
    }

    componentDidUpdate() {
        if(this.props.appToLoad !== apps.QMS){
            return;
        }
        let scrollableSubMenu = document.getElementById("filetrace$Menu");
        if (scrollableSubMenu !== null) {
          //scrollableSubMenu.addEventListener("scroll", function (){ alert("LUL")});
          scrollableSubMenu.onscroll = this.scrollMenu;
        }
    
        if(this.props.allowAutoSelect && (JSON.parse(sessionStorage.getItem('sessionData')) === null)){
            // alert("Clicking")
            const event = new MouseEvent("click", {
                view: window,
                bubbles: true,
                cancelable: true
            });

            let firstSession = null;
            if(this.props.accessType === accessType.END_USER && this.firstTime != null ){
                firstSession = document.getElementById('Nav_'+this.firstTime);
                if (firstSession != null) {
                    //alert("DoClick");
                    const cancelled = !firstSession.dispatchEvent(event);
            
                    if (cancelled) {
                    //alert("cancelled");
                    }
                }
            }else if([accessType.CORPORATE, accessType.ONBOARDING_TEAM].includes(this.props.accessType)
             && this.firstDate != null){
                firstSession = document.getElementById('Nav_'+this.firstDate);
                if (firstSession != null) {
                    //alert("DoClick");
                    const cancelled = !firstSession.dispatchEvent(event);
            
                    if (cancelled) {
                    //alert("cancelled");
                    }
                }

            }
        }
        
    }

    async componentDidMount() {
        window.addEventListener("resize", () => this.updateDimensions());
        if(this.props.appToLoad === apps.COMPLIANCE){
            this.props.setToggleSidebar()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.updateDimensions());
    }

    
    createContent(init, scrollDown){
        if(this.props.appToLoad !== apps.QMS){
            return;
        }
        if(this.state.solution.solutionName === ""){
            return
        }
        if( this.state.uniqueIndexes.length === 0   
            && this.props.accessType === accessType.CORPORATE){
            this.printError({
                display: true,
                err: true,
                errCode: '500',
                errType: '',
                errMsg: 'Unique indexes not set'
            });
            return
        }
        // alert("getting data "+JSON.stringify(this.state.solution));
        let container = null;
        let shei = null;
        let scY = null;
        let clHei = null;

        // alert("DATA : "+this.state.solution);
        //let page = this.state.page;
        if(!init){
            container = document.getElementById("filetrace$Menu");
            shei = container.scrollHeight;
            scY = container.scrollTop;
            clHei = container.clientHeight;
            container.style.overflowY = "hidden";
        }
        let user = { ...this.props.user };
        let afterKey = this.state.afterKey;
        let archiveKey = this.state.archiveKey;
        //let userId = user.sub.replace("auth0|", "").toString();
        let userId = user["https://myapp.com/UserName"];
        //if scrolling downwards
        if(scrollDown){
            axiosInstanceQMS.post("/api/fileTrace/getUserAggregatedFileTraceSessions",
                {
                    "user" : user.name,
                    "email" : user.email,
                    //"page" : page,
                    "size" : this.state.pageSize,
                    "afterKey" : afterKey,
                    "archiveKey" : archiveKey,
                    "pms" : (sessionStorage.getItem('pms') === "null")?null:sessionStorage.getItem('pms'),
                    "userId" : userId,
                    "from" : (this.props.accessType === accessType.END_USER)?"FT":"GM",
                    "accessType" : this.props.accessType,
                    "solution" : this.state.solution.solutionName,
                    "projectDetails" : this.state.solution.projectDetails,
                    "allowedConnectors" : this.state.allowedConnectors,
                    "uniqueIndexes" : this.state.uniqueIndexes
                })
            .then(response => {
                this.apiCalled = true;
                
                if(response.data.error){
                    console.error("ERROR :", response.data.errorMessage);
                    let errorMessage = (response["data"]["display"] != undefined && response["data"]["display"])?response["data"]["errorMessage"]:'Error occured';
                    this.printError({
                        display: true,
                        err: true,
                        errCode: '500',
                        errType: '',
                        errMsg: errorMessage
                    });

                    return;
                }
                let result = response.data.data;
                let bucketSize = Object.keys(result.buckets).length;

                let stateSessions = {... this.state.sessions};
                //let stateSessions = {... this.sessions};
                let emptyFileTrace = false;
                if(bucketSize > 0){
                    
                    if(bucketSize >= this.state.pageSize){
                        if(!result.archiveUsed){
                            this.state.afterKey = ++afterKey;
                        }else{
                            this.state.archiveKey = ++archiveKey;
                        }
                    }else if(bucketSize < this.state.pageSize){
                        this.endOfData = true;
                    }
                    
                    let dteKeys = Object.keys(result.buckets);
                    for( let x = 0 ; x < dteKeys.length ; x++){
                        let bucketKey = dteKeys[x];
                        let timeList = result.buckets[bucketKey];
                        
                        for(let y = 0 ; y < timeList.length  ; y++){
                            let formatted = moment(bucketKey+" "+timeList[y], 'MM-DD-YYYY hh:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
                            let dte = moment.utc(formatted);
                            
                            let localSession = moment(dte).local();
                            let fmtSessionTime = moment(localSession).format('hh:mm:ss A');
                            let fmtSessionDate =  moment(localSession).format('MM-DD-YYYY');
                            
                            if(fmtSessionDate in stateSessions){
                                stateSessions[fmtSessionDate].push(fmtSessionTime);
                            }else{
                                stateSessions[fmtSessionDate] = [fmtSessionTime]
                            }
                        }

                    }
                    //this.sessions = stateSessions;
                    //this.processSessions();
                }else{
                    if(this.state.afterKey === 0){
                        emptyFileTrace = true;
                    }
                    this.endOfData = true;
                }
                this.setState({
                    "sessions" : stateSessions,
                    "emptyFileTrace" : emptyFileTrace
                });

                if(!init){
                    container.style.overflowY = "auto";
                    container.scrollTop = scY-5;
                }
                //alert(JSON.stringify(this.state.afterKeyList) +" ::: "+this.state.opendMenus+" ::: "+this.state.opendSubMenus);
            }).catch((error) => { 
                if(!init){
                    container.style.overflowY = "auto";
                    container.scrollTop = scY-5;
                }
                console.error("ERROR :",error);
                this.printError({
                    display: true,
                    err: true,
                    errCode: '400',
                    errType: '',
                    errMsg: 'Error occured : '+error.message
                });
                
            });
        }else{
            container.style.overflowY = "auto";
            return;
        }
        
    }

    toggle() {
        this.setState(prevState => ({
            isOpen : !prevState.isOpen
        }));
    }

    render() {
        if(this.props.appToLoad === apps.QMS){
        
            console.log("sidebar rendered", this.props.sideBarSelected)

            let keys = Object.keys(this.state.sessions);
            //if(keys.length > 0){
            if(this.firstExe && keys.length == 0 && this.apiCalled){
                this.props.setFiletraceContentLoading(false);
            }

            let dateSets = [];
            keys.forEach((date) => {
                if (this.firstDate === null) {
                    this.firstDate = date;
                }

                let timeMenuItems = [];

                if(this.props.accessType === accessType.END_USER){
                    this.state.sessions[date].forEach((time) => {
                        let timeKey = date+"_"+time;
                        if (this.firstTime === null) {
                            this.firstTime = timeKey;
                        }
                        let timeMenuItem = (
                        <Menu.Item
                            key={timeKey}
                            id={timeKey}
                            onClick={() => {
                            this.handleMe(timeKey, "t", true);
                            }}
                        >
                            <NavLink id={'Nav_'+timeKey} to="/filetrace">{time}</NavLink>
                        </Menu.Item>
                        );
        
                        timeMenuItems.push(timeMenuItem);
                    });
                }

                let dateSubMenu = "";
                if(this.props.accessType === accessType.END_USER){
                    dateSubMenu = (
                        <SubMenu
                            key={date}
                            id={date}
                            onTitleClick={() => {
                                this.handleMe(date, "d", true);
                            }}
                            title={date}
                        >
                        {timeMenuItems}
                        </SubMenu>
                    );

                }else{
                    dateSubMenu = <Menu.Item
                            key={date}
                            id={date}
                            onClick={() => {
                                this.handleMe(date, "d", true);
                            }}
                        >
                            <NavLink id={'Nav_'+date} to="/filetrace">{date}</NavLink>
                        </Menu.Item>
                }

                dateSets.push(dateSubMenu);
            });

            //alert("FE :" + this.firstExe + " :: DS :" + dateSets.length);
            if ((this.props.allowAutoSelect || this.props.dateComponent != null) && this.firstExe && keys.length > 0) {
                this.firstExe = false;

                if(this.absoluteInit && this.props.dateComponent !== null){
                    this.absoluteInit = false;
                    let splitDate = this.props.dateComponent.split("T");
                    if(splitDate[1] != undefined && splitDate[1] !== ""){
                        
                        let dte = moment.utc(this.props.dateComponent);
                        let localSession = moment(dte).local();
                        let fmtSessionTime = moment(localSession).format('hh:mm:ss A');
                        let fmtSessionDate =  moment(localSession).format('MM-DD-YYYY');
                        
                        this.firstTime = fmtSessionDate+"_"+fmtSessionTime;
                        this.firstDate = fmtSessionDate;
                    }else{
                        this.firstDate = moment(splitDate[0], "YYYY-MM-DD").format('MM-DD-YYYY');
                        this.firstTime = null;
                    }
                }

                let stateMenu = [...this.state.selectedMenu];
                let stateItem = [...this.state.selectedItems];
                if(this.props.accessType === accessType.END_USER){
                    if (!stateMenu.includes(this.firstDate)) {
                        stateMenu.push(this.firstDate);
                    }

                    if(this.firstTime != null){
                        stateItem = [this.firstTime];
                    }
                }else{
                    stateItem = [this.firstDate];
                }

                this.state.selectedMenu = stateMenu;
                this.state.selectedItems = stateItem;
                // alert("Sub : "+JSON.stringify(this.state.selectedMenu));
                // alert("Item : "+JSON.stringify(this.state.selectedItems));
            }

            this.state.dateSets = dateSets;
            // alert("Sub : "+JSON.stringify(this.state.selectedMenu));
            // alert("Item : "+JSON.stringify(this.state.selectedItems));
            
            return (
                <>
                    {console.log("last selected date",this.state.selectedItems)}
                    <QMSErrorHandle errordetails={this.errorObject} />
                    <Sider trigger={null} collapsible collapsed={!this.props.isOpen} className="qms-sidebar">
                    <FontAwesomeIcon icon={faBars} size="lg" className={classNames('sideBarHambuger',{'is-open':this.props.isOpen})} onClick={this.props.setToggleSidebar}/>
                        {/* <div className={classNames('logo-wrapper', { 'is-open': !this.props.isOpen })}>
                            <a href={REACT_APP_SSO_URL}>
                                {
                                    this.props.isOpen ? (
                                        <img src={cloudlogo} alt="mydigitaloffice" />
                                    ) : (
                                        <img src={logo} alt="mydigitaloffice" />                        
                                    )
                                }
                            </a>
                        </div> */}
                        {(this.apiCalled)?(
                            <Menu
                                //style={{ width: 256 }}
                                defaultOpenKeys={this.state.selectedMenu}
                                selectedKeys={(!this.props.sideBarSelected?[]:this.state.selectedItems)}
                                mode="inline"
                                theme="dark"
                                forceSubMenuRender
                            >
                                {(this.state.emptyFileTrace)?(
                                    <Menu.Item 
                                        key="filetrace"
                                        id="filetrace"
                                        onClick={() => {
                                            this.handleMe("filetrace", "0", true);
                                        }}
                                    >
                                        <NavLink to="/filetrace">
                                            {<FileSearchOutlined />}
                                            <span>File Trace</span>
                                        </NavLink>
                                    </Menu.Item>
                                ):(
                                    <SubMenu
                                        key="filetrace"
                                        id="filetrace"
                                        onTitleClick={() => {
                                            this.handleMe("filetrace", "d", false);
                                        }}
                                        icon={<FileSearchOutlined />}
                                        title={"Filetrace"}
                                    >
                                        {this.state.dateSets}
                                    </SubMenu>
                                )}
                            </Menu>
                        ):<></>}
                   </Sider>
                </>
            );
        }else{
            return (
                <>
                    <QMSErrorHandle errordetails={this.errorObject} />
                    {this.state.winWidth < 768 ? "" : (
                        <Sider trigger={null} collapsible collapsed={!this.props.isOpen}  className="qms-sidebar">
                        <FontAwesomeIcon icon={faBars} size="lg" className={classNames('sideBarHambuger',{'is-open':this.props.isOpen})} onClick={this.props.setToggleSidebar}/>
                            
                            {/* <div className={classNames('logo-wrapper', { 'is-open': !this.props.isOpen })}>
                                <a href={REACT_APP_SSO_URL}>
                                    {
                                        this.props.isOpen ? (
                                            <img src={cloudlogo} alt="mydigitaloffice" />
                                        ) : (
                                            <img src={logo} alt="mydigitaloffice" />
                                            
                                        )
                                    }
                                </a>
                            </div> */}

                        </Sider>
                    )}
                </>
            );
        }

    }
}

function mapStateToProps(state){
    let sidebarReducer = state.sidebarReducer;
    let navbarReducer = state.navbarReducer;
    return {
        solution : sidebarReducer.solution,
        allowedConnectors : sidebarReducer.allowedConnectors,
        uniqueIndexes : sidebarReducer.uniqueIndexes,
        isOpen : navbarReducer.isOpen,
        sideBarSelected : navbarReducer.sideBarSelected,
    }
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({ 
        setFiletraceContentLoading : setFiletraceContentLoading,
        setToggleSidebar:setToggleSidebar,
        setSidebarSelected: setSidebarSelected
     }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(SideBar);